import React from 'react';
import { Star, Globe, Network, GraduationCap, Check } from 'lucide-react';
import { waynePartnershipData } from '../data/mock';

const iconMap = {
  Star: Star,
  Globe: Globe,
  Network: Network,
  GraduationCap: GraduationCap,
};

const PartnersSection = () => {
  return (
    <section id="partners" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Visual with real Wayne images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              {/* Main large image */}
              <div className="col-span-2 rounded-3xl overflow-hidden shadow-xl">
                <img
                  src="https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/ituqbtbi_PHOTO-2025-10-10-21-03-55%202.jpg"
                  alt="Wayne Station"
                  className="w-full h-64 object-cover"
                />
              </div>
              
              {/* Two smaller images */}
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/dkm27cn5_PHOTO-2025-10-10-21-03-55.jpg"
                  alt="Wayne Fuel Pump"
                  className="w-full h-40 object-cover"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://customer-assets.emergentagent.com/job_5cce6493-f0af-4302-8a9d-51bbe4853e8f/artifacts/i47yjj93_PHOTO-2025-10-10-21-04-26%2026.jpg"
                  alt="Wayne Equipment"
                  className="w-full h-40 object-cover"
                />
              </div>
            </div>

            {/* Stats floating cards */}
            <div className="absolute -left-4 top-1/3 bg-white rounded-xl p-4 shadow-lg border border-slate-100">
              <p className="text-2xl font-bold text-orange-500">500M+</p>
              <p className="text-xs text-slate-500">USD Investis en Afrique</p>
            </div>

            <div className="absolute -right-4 bottom-20 bg-white rounded-xl p-4 shadow-lg border border-slate-100">
              <p className="text-2xl font-bold text-orange-500">140</p>
              <p className="text-xs text-slate-500">Ans d'Excellence</p>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 rounded-full mb-6">
              <span className="text-sm font-medium text-orange-700">Notre Partenaire</span>
            </div>

            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6">
              {waynePartnershipData.title}
            </h2>

            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              {waynePartnershipData.description}
            </p>

            {/* Highlights */}
            <ul className="space-y-3 mb-8">
              {waynePartnershipData.highlights.map((highlight, index) => (
                <li key={index} className="flex items-center gap-3">
                  <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <Check className="w-4 h-4 text-green-600" />
                  </div>
                  <span className="text-slate-700">{highlight}</span>
                </li>
              ))}
            </ul>

            {/* Benefits Grid */}
            <div className="grid grid-cols-2 gap-4">
              {waynePartnershipData.benefits.map((benefit, index) => {
                const IconComponent = iconMap[benefit.icon];
                return (
                  <div
                    key={index}
                    className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl hover:bg-orange-50 transition-colors"
                  >
                    <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm">
                      <IconComponent className="w-5 h-5 text-orange-500" />
                    </div>
                    <span className="text-sm font-medium text-slate-700">
                      {benefit.title}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
